module.exports = __webpack_public_path__ + "static/proud-d06bf5407643dcd2ba7e88ffe30ef4ec.jpg";